import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { AuthService } from '../auth/auth.service';
import { UIService } from '../shared/ui.service';
import { Router } from '@angular/router';
import { MatDialog } from '@angular/material';
import { AccessService, Permission } from './access.service';
import { Access, User } from '../auth/user.model';
import { Subscription } from 'rxjs/index';
import { StorageService } from '../storage/storage.service';
import { AccessDetailsComponent } from './dialog/access-details/access-details.component';
import { AccessInvitationComponent } from './dialog/access-invitation/access-invitation.component';

@Component({
  selector: 'app-access',
  templateUrl: './access.component.html',
  styleUrls: ['./access.component.css']
})
export class AccessComponent implements OnInit {
  user: User;
  accesses: Access[];
  isLoading = false;
  currentProject: number;
  hasAccessToData: boolean;

  private loadingSubscription: Subscription;
  private selectedProjectSubscription: Subscription;

  constructor(
    private accessService: AccessService,
    private authentication: AuthService,
    private storageService: StorageService,
    private uiService: UIService,
    private router: Router,
    private _ref: ChangeDetectorRef,
    public dialog: MatDialog
  ) { }

  ngOnInit() {
    this.currentProject = this.storageService.getPreferredProject();
    this.loadingSubscription = this.uiService.loadingStateChanged.subscribe(isLoading => {
      this.isLoading = isLoading;
      this._ref.markForCheck();
    });
    this.user = this.authentication.getUser();
    this.getAccesses();
    this.selectedProjectSubscription = this.uiService.selectedProjectChanged.subscribe(projectId => {
      this.currentProject = projectId
      this.getAccesses();
      this.hasAccessToData = this.validateAccessToData();
    });

  }

  validateAccessToData() {
    return this.authentication.hasAccessToProject(this.currentProject, Permission.ADMIN);
  }

  getAccesses() {
    this.accessService.getAccesses(this.user.token).subscribe((response: Access[]) => {
        this.accesses = response;
        this.uiService.loadingStateChanged.next(false);
        this.hasAccessToData = this.validateAccessToData();
    },(error: Error) => {
        if(error ){
          this.accesses = [];
      }});
  }

  onInviteNewMember(event: Event){
    const dialogRef = this.dialog.open(AccessInvitationComponent, {
      data: -1,
    });

    dialogRef.afterClosed().subscribe(result => {
      this.getAccesses();
    });
  }

   openDialog(accessId): void {
    const dialogRef = this.dialog.open(AccessDetailsComponent, {
      data: accessId,
    });

    dialogRef.afterClosed().subscribe(result => {
      this.getAccesses();
    });
  }


  ngOnDestroy() {
    this.loadingSubscription.unsubscribe();
    this.selectedProjectSubscription.unsubscribe();
  }

}
